/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The data-ids used for the Capability Switcher component.
 * @export
 */
export const CAPABILITY_SWITCHER_DATA_IDS = {
  switcherDropdownItem: `Toolbar: Capability switcher button: Navigate to {{capability}} capability`,
  switcherDropdownItemHome: `Toolbar: Capability switcher button: Navigate to Home`,
};
